<template>
  <figure class="figure grid-x align-center">
    <div class="cell" :class="{ 'small-10 medium-6': contain }">
      <img
        class="image"
        :src="image.url"
        :height="image.height"
        :width="image.width"
        :alt="image.title"
      />
      <figcaption class="caption" v-if="caption" v-html="caption" />
    </div>
  </figure>
</template>

<script>
export default {
  props: {
    image: Object,
    caption: String,
    contain: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "foundation-sites/scss/foundation.scss";
@import "@/assets/scss/_settings";
.figure {
  margin: vw-relative(24 0, 320);
  @include breakpoint(medium) {
    margin: vw-relative(24 0);
  }
}
.image {
  width: 100%;
  height: auto;
}
.caption {
  font: 18px/1.2 CenturyGothic;
  @include clamp-font(14px, 18px);
  margin-top: 0.4em;
  color: #4c5fa1;
  background-color: #f1f1f2;
  padding: 0.4em;
}
</style>
